var map = {
	"./404.svg": "8a81",
	"./Checkmark.svg": "b376",
	"./CodeLink.svg": "c6c6",
	"./CompassNeedle.svg": "8814",
	"./GitHub-Mark-Light-64px.png": "9298",
	"./GreenPoint.svg": "b6af",
	"./Group.png": "f0b9",
	"./In-White-40.png": "7141",
	"./LinkGreen.svg": "d260",
	"./Links.svg": "d47a",
	"./LinksThumbnail.svg": "c312",
	"./LinksWhite.svg": "c86f",
	"./NorwayAccent.svg": "556c",
	"./NorwayWhite.svg": "401c",
	"./React.svg": "24e0",
	"./Sarah.svg": "a001",
	"./SignBackground.svg": "2eb2",
	"./SingleLinkWhite.svg": "9f78",
	"./SiteIcon.svg": "733b",
	"./SiteLink.svg": "46cb",
	"./UKaccent.svg": "b54e",
	"./UKwhite.svg": "c785",
	"./Vue.svg": "b4bf",
	"./Webp.net-gifmaker.gif": "e39a",
	"./checkmarkGif.gif": "76ac",
	"./divider.png": "73f4",
	"./dividerBlack.png": "18f7",
	"./dividerShortBlack.png": "5864",
	"./dividerShortGreen.png": "ddda",
	"./forBarnaThumbnail.png": "29c0",
	"./icons/EducationDivider.svg": "2375",
	"./icons/Exit.svg": "9092",
	"./icons/Flag.svg": "2c53",
	"./icons/HamburgerMenu.svg": "128e",
	"./icons/LinksThumbnail.svg": "ec89",
	"./icons/Mailbox.svg": "90fe",
	"./icons/Mailbox1.svg": "18f6",
	"./icons/Mailbox2.svg": "3e7e",
	"./icons/Mailbox3.svg": "fd5c",
	"./icons/Mailbox4.svg": "9428",
	"./icons/Mailbox5.svg": "c6c2",
	"./icons/MailboxShell.svg": "9ce9",
	"./icons/Skills.svg": "ff18",
	"./icons/SkillsCompact.svg": "e391",
	"./icons/SkillsDivider.svg": "590d",
	"./icons/dividerShortGreen.png": "04cd",
	"./logo.png": "cf05",
	"./quoteEnd.svg": "6e78",
	"./quoteStart.svg": "f359",
	"./screenshots/burgerBuilder1.png": "0958",
	"./screenshots/burgerBuilder2.png": "032d",
	"./screenshots/burgerBuilder3.png": "cf76",
	"./screenshots/forBarna1.png": "431f",
	"./screenshots/forBarna2.png": "ac99",
	"./screenshots/forBarna3.png": "77fa",
	"./screenshots/myBoard1.png": "9632",
	"./screenshots/portfolio1.png": "439b",
	"./screenshots/portfolio2.png": "ca59",
	"./screenshots/portfolio3.png": "d726",
	"./screenshots/retro1.png": "ca76",
	"./screenshots/retro2.png": "59ee",
	"./screenshots/retro3.png": "b342"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";